import { AUTH_OTP_REQUEST } from '@alfa-bank/site-envconfig';
import { httpClient } from '@alfa-bank/site-http-client';

import type { ICodesRequestResponse } from '../models';

/**
 * Передача номера телефона для отправки кода подтверждения.
 * {@link  - https://confluence.moscow.alfaintra.net/pages/viewpage.action?pageId=1927163237 - аналитика}
 */
export const requestConfirmationCode = (phone: string, prodType: string) =>
    httpClient.post<ICodesRequestResponse>(AUTH_OTP_REQUEST(), { phone, prodType });
